import React from 'react';
import { useNavigate } from 'react-router-dom';
import { postLogout } from '../api/loginApi';

export function Home() {
  const navigate = useNavigate();

  const signOut = () => {
    postLogout().then(() => {
      navigate('/login');
    });
  };

  return (
    <>
      <h2 className="column-flex align-center">Welcome to the Home Page!</h2>
      <button type="button" onClick={() => navigate('/todos')}>
        Go to Todos
      </button>
      <button type="button" onClick={signOut}>
        Sign out
      </button>
    </>
  );
}
